// Product-page (PDP) media registry — every swappable photo/video on the mask page.
// Defaults are snapshotted from the authentic Aura Glow imagery at module load.
// Admin uploads (via /api/media) override a slot at runtime; storefront falls back to default.
import { IMG } from "@/data/catalog";

const V = "https://cdn.shopify.com/videos/c/o/v";
const MARION_IMG = "https://static.prod-images.emergentagent.com/jobs/6e9e37ac-1f04-43a6-819a-203cd06632b4/images/d5761b722a4cc152ea481b73d2a9e57a426e5a274718d2dc63238192b29a51cb.png";
const LEOPARD_IMG = "https://static.prod-images.emergentagent.com/jobs/6e9e37ac-1f04-43a6-819a-203cd06632b4/images/d3f4fdffa813140df70b0364075c1c1ef38ac0c747fb58d7cba6a66005229724.png";
const VID_RESULTS = `/videos/results.mp4`;
const VID_GLOW = `${V}/296b8a21976748738ad19a5209451830.mp4`;
const VID_UNBOX = `${V}/12f5e9eb569a4d4d8cefcfe0dc952e58.mp4`;
const VID_RITUAL = `/videos/ritual.mp4`;
const VID_REAL = `${V}/1b6cdb1e7d3a4c9095203904956bfea7.mp4`;
const VID_TRANSFORM = `/videos/transform.mp4`;

// Ordered for the admin Media Manager (grouped by section).
export const PDP_MEDIA = [
  // Home page
  { key: "home_hero", label: "Hero banner (model + mask)", group: "Home Page", type: "image", def: "/hero-model-v2.webp" },
  { key: "home_object_main", label: "Home — 'The Object' main", group: "Home Page", type: "image", def: IMG.lifestyleMask },
  { key: "home_object_detail", label: "Home — 'The Object' inset", group: "Home Page", type: "image", def: IMG.deviceDetail },
  { key: "home_whoweare", label: "Home — 'Who We Are'", group: "Home Page", type: "image", def: IMG.glowFront },
  { key: "home_science_mask", label: "Home — LED / science mask", group: "Home Page", type: "image", def: IMG.maskCutout },
  { key: "home_results", label: "Home — before / after", group: "Home Page", type: "image", def: MARION_IMG },
  { key: "home_story_leopard", label: "Home — design story leopard", group: "Home Page", type: "image", def: LEOPARD_IMG },
  { key: "pdp_every_detail", label: "'Every detail, considered.' mask", group: "Home Page", type: "image", def: IMG.maskCutout },
  { key: "anatomy_leds", label: "Anatomy — 114 LEDs", group: "Home Page", type: "image", def: IMG.product },
  { key: "anatomy_wavelengths", label: "Anatomy — 3 wavelengths", group: "Home Page", type: "image", def: IMG.deviceDetail },
  { key: "anatomy_modes", label: "Anatomy — 8 smart modes", group: "Home Page", type: "image", def: IMG.leopardSilk },
  { key: "anatomy_silicone", label: "Anatomy — flexible silicone", group: "Home Page", type: "image", def: IMG.glowFront },
  { key: "anatomy_timer", label: "Anatomy — 10-min timer", group: "Home Page", type: "image", def: IMG.lifestyleMask },
  { key: "anatomy_usbc", label: "Anatomy — USB-C rechargeable", group: "Home Page", type: "image", def: IMG.unboxing },
  // About page
  { key: "about_hero", label: "About — hero banner", group: "About Page", type: "image", def: IMG.lifestyleMask },
  { key: "about_difference", label: "About — 'Our Difference'", group: "About Page", type: "image", def: IMG.glowFront },
  { key: "about_craft", label: "About — 'Behind The Product'", group: "About Page", type: "image", def: IMG.deviceDetail },
  { key: "about_results", label: "About — before / after", group: "About Page", type: "image", def: MARION_IMG },
  { key: "about_closing", label: "About — closing background", group: "About Page", type: "image", def: IMG.leopardSilk },
  // Science page
  { key: "science_hero", label: "Science — hero background", group: "Science Page", type: "image", def: IMG.wavelengthGlow },
  { key: "science_research", label: "Science — research portrait", group: "Science Page", type: "image", def: IMG.dermatologist },
  // Shop page product cards
  { key: "shop_single", label: "Shop — LED mask card", group: "Shop Page", type: "image", def: IMG.product },
  { key: "shop_serum", label: "Shop — serum card", group: "Shop Page", type: "image", def: IMG.serum },
  { key: "shop_cleanser", label: "Shop — cleanser card", group: "Shop Page", type: "image", def: IMG.cleanser },
  // Gallery
  { key: "pdp_gallery_1", label: "Main image", group: "Gallery", type: "image", def: IMG.product },
  { key: "pdp_gallery_2", label: "Angled glow", group: "Gallery", type: "image", def: IMG.glowFront },
  { key: "pdp_gallery_3", label: "Device detail", group: "Gallery", type: "image", def: IMG.deviceDetail },
  { key: "pdp_gallery_4", label: "Unboxing / box", group: "Gallery", type: "image", def: IMG.unboxing },
  { key: "pdp_gallery_5", label: "In use / lifestyle", group: "Gallery", type: "image", def: IMG.apply },
  { key: "pdp_gallery_6", label: "Flexible fit", group: "Gallery", type: "image", def: IMG.flexible },
  // Buy box
  { key: "pdp_buybox_avatar", label: "Featured review avatar", group: "Buy Box", type: "image", def: IMG.skinB },
  { key: "pdp_review_photo", label: "Google review avatar", group: "Transformations", type: "image", def: IMG.skinB },
  { key: "pdp_buybox_video_1", label: "Video 1 — 8-week results", group: "Buy Box", type: "video", def: VID_RESULTS },
  { key: "pdp_buybox_video_2", label: "Video 2 — see the glow", group: "Buy Box", type: "video", def: VID_GLOW },
  // Pain points
  { key: "pdp_painpoints", label: "Pain points portrait", group: "What It Solves", type: "image", def: IMG.matureC },
  // Benefits (editorial)
  { key: "pdp_editorial_1", label: "Benefit feature 1", group: "Benefits", type: "image", def: IMG.flexible },
  { key: "pdp_editorial_2", label: "Benefit feature 2", group: "Benefits", type: "image", def: IMG.glowFront },
  // How it works
  { key: "pdp_research", label: "Science section portrait", group: "How It Works", type: "image", def: IMG.matureA },
  { key: "pdp_howto_1", label: "How-to step 1 (cleanse)", group: "How It Works", type: "image", def: IMG.stepCleanse },
  { key: "pdp_howto_2", label: "How-to step 2 (mask up)", group: "How It Works", type: "image", def: IMG.glowFront },
  { key: "pdp_howto_3", label: "How-to step 3 (glow)", group: "How It Works", type: "image", def: IMG.stepGlow },
  { key: "pdp_dayinlife", label: "Day in the life video", group: "How It Works", type: "video", def: VID_RESULTS },
  // Features / specs
  { key: "pdp_feature_1", label: "Feature — Colour modes", group: "Features", type: "image", def: IMG.wavelengthGlow },
  { key: "pdp_feature_2", label: "Feature — Irradiance", group: "Features", type: "image", def: IMG.deviceDetail },
  { key: "pdp_feature_3", label: "Feature — Material", group: "Features", type: "image", def: IMG.flexible },
  { key: "pdp_feature_4", label: "Feature — Straps", group: "Features", type: "image", def: IMG.apply },
  { key: "pdp_feature_5", label: "Feature — Packaging", group: "Features", type: "image", def: IMG.unboxing },
  { key: "pdp_feature_6", label: "Feature — Benefits", group: "Features", type: "image", def: IMG.stepGlow },
  { key: "pdp_inbox", label: "What's in the box", group: "Features", type: "image", def: IMG.product },
  // Results & reviews
  { key: "pdp_transformation", label: "Before / after transformation", group: "Results & Reviews", type: "image", def: IMG.beforeAfter },
  { key: "pdp_ugc_1", label: "UGC video 1", group: "Results & Reviews", type: "video", def: VID_TRANSFORM },
  { key: "pdp_ugc_2", label: "UGC video 2", group: "Results & Reviews", type: "video", def: VID_UNBOX },
  { key: "pdp_ugc_3", label: "UGC video 3", group: "Results & Reviews", type: "video", def: VID_RITUAL },
  { key: "pdp_ugc_4", label: "UGC video 4", group: "Results & Reviews", type: "video", def: VID_REAL },
];

const DEFAULTS = Object.fromEntries(PDP_MEDIA.map((m) => [m.key, m.def]));
const OVERRIDES = {};

// First-frame posters for each video slot (auto-generated from the clip's own frame).
// Admin video uploads add a runtime `${slot}__poster` override via /api/media.
const POSTER_DEFAULTS = {
  pdp_buybox_video_1: "/videos/results.jpg",
  pdp_buybox_video_2: "/videos/glow.jpg",
  pdp_ugc_1: "/videos/transform.jpg",
  pdp_ugc_2: "/videos/unbox.jpg",
  pdp_ugc_3: "/videos/ritual.jpg",
  pdp_ugc_4: "/videos/real.jpg",
  pdp_dayinlife: "/videos/results.jpg",
};

// Resolve the poster (still image shown before a video plays) for a video slot.
export function posterUrl(slot) {
  return OVERRIDES[`${slot}__poster`] || POSTER_DEFAULTS[slot] || "";
}

// Merge admin overrides (slot -> url). Relative /api urls get the backend prefix.
export function applyMediaOverrides(map, backendUrl = "") {
  Object.entries(map || {}).forEach(([slot, url]) => {
    if (!url) return;
    OVERRIDES[slot] = url.startsWith("http") ? url : `${backendUrl}${url}`;
  });
}

// Resolve the live URL for a slot (override if set, else original default).
export function mediaUrl(slot) {
  return OVERRIDES[slot] || DEFAULTS[slot] || "";
}

// Set/clear a single override at runtime (used by the on-site media editor).
export function setMediaOverride(slot, url, backendUrl = "") {
  if (!url) { delete OVERRIDES[slot]; return; }
  OVERRIDES[slot] = url.startsWith("http") ? url : `${backendUrl}${url}`;
}

export function slotDefault(slot) {
  return DEFAULTS[slot] || "";
}

export function slotMeta(slot) {
  return PDP_MEDIA.find((m) => m.key === slot) || null;
}
